var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.noticeClass}-notice`},[_c('icon',{attrs:{"name":`alert-${_vm.noticeClass}`}}),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }